import React, { useState } from "react";
import {Box, Paper, Table, Checkbox, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Button} from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import MainCard from './MainCard';



const SelectTable = ({ rows, columns, handleDownload, title, selected, setSelected }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [runSum, setRunSum] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const sum_runningPacketTime = (selected.length === 0)? 0:(runSum/3600).toFixed(1);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      setRunSum(0);
      let sum = rows.reduce((runSum, object) => {
        return runSum + object.runningPacketTime;
      }, 0);
      setRunSum(sum);
      return;
    }
    setSelected([]);
    setRunSum(0);
  };

  const handleClick = (event, name, runningPacketTime) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
    setRunSum(0);
    let sum = rows.reduce(function(runSum, object) {
     return (newSelected.indexOf(object.name) === -1) ? runSum : runSum + object.runningPacketTime;
    }, 0);
    setRunSum(sum);
  };

  return (
    <MainCard title={title}>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
    <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px', padding: "15px",}}>
         Running Sum:  { sum_runningPacketTime } hours
      </Box>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
            <TableCell padding="checkbox" sx={{ bgcolor: "#406599", color:"white" }}>
              <Checkbox
                color="primary"
                onChange={handleSelectAllClick}
                inputProps={{
                  'aria-label': 'select all items',
                }}
              />
            </TableCell>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sx={{ minWidth: column.minWidth, bgcolor: "#406599", color:"white" }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const uuid = row.name;
                const isItemSelected = isSelected(row.name);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                <TableRow
                  hover
                  role="checkbox"
                  onClick={(event) => handleClick(event, row.name, row.runningPacketTime)}
                  tabIndex={-1}
                  key={row.name}
                  selected={isItemSelected}>
                    <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                    </TableCell>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                        {typeof value === 'boolean'?
                          (value === false ? 'False':'True'):
                          (column.action?
                            (<div><Button onClick={() => handleDownload(uuid)}><CloudDownloadIcon sx={{ color: "#406599",fontSize: 20 }}/></Button></div>):
                            (value))}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ bgcolor: "#406599", color:"white" }}
      />
    </Paper>
    </MainCard>
  );
}

export default SelectTable;
